exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app-container {\n  background: url(/assets/images/LV_Customer360_Background.png) repeat-x;\n  background-color: #568aad;\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 3.125rem; /* Global Header height */\n}\n\n.app-container.df18Brunello {\n  background: url(/assets/images/LV_Customer360_Background.png) repeat;\n  /*background-position-x: 150px;\n  background-position-y: -350px;*/\n}\n\n.app-body {\n  height: 100%;\n}\n\n.demo-listing .slds-global-header__logo {\n  height: 3rem;\n  margin-left: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/App/app.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/App/app.css
// module chunks = 0